<app-spinner [(show)]="loading"></app-spinner>
<main class="esf-main-content -has-transition -width-max" *ngIf="!loading">
  <div class="esf-container main-content--fit-screen">

    <h1 class="esf-heading esf-heading--page esf-action-heading">
      <div class="esf-action-heading__text">
        <span i18n='Page heading@@userListComponent.heading.users'>Users</span>
      </div>
      <span class="esf-action-heading__actions">
        <span class="esf-action-heading__action">
          <button class="esf-button esf-button--filled esf-button--icon esf-button--icon-small"
                  (click)="userModalService.toggleModal(true)"
                  [edsTooltip]="tooltipTranslations.i18nCreateNewUser">
            <svg class="esf-icon" width="16" height="16">
              <use xlink:href="#esf-icon-plus"></use>
            </svg>
          </button>
        </span>
      </span>
    </h1>

    <div class="esf-form-item"
         app-form-field-search
         [placeholder]="flTranslations.i18nSearchUser"
         [id]="'search'"
         [control]="options.get('orSearchAll')"
         (inputChanged)="triggerSearch()">
    </div>

    <app-paginated-table [columns]="columns"
                         [keys]="keys"
                         [data]="data"

                         [baseApi]="baseApi"
                         [customQueries]="customQueries"
                         (dataFetchedEmitter)="showUserList($event)"

                         (rowClickEvent)="routerLink($event)"

                         [emptyStateIcon]="'#esf-icon-bell-32'">
    </app-paginated-table>
  </div>
</main>

<app-club-user-create [listOfClubs]="listOfClubs" *ngIf="userModalService.modalOpened"></app-club-user-create>
